import React, { useCallback, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FleetContext } from "../../shared/components/page_base";
import Header from "./header";
import { Box } from "@mui/material";
import FleetSummary from "./fleet_summary";
import RobotSummary from "./robot_summary";
import MultiDayGraphList from "./multi_day_graph_list";
import SoloDayGraphList from "./solo_day_graph_list";
import { getReportByDate } from "../actions/report.action";

function ReportPage() {
  document.title = "Report | Cyberworks Robotics Fleet Management";
  let { fleetId } = useParams();
  const { fleetData } = useContext(FleetContext);
  const [selectedFleet, setSelectedFleet] = useState(null);
  const [fromDate, setFromDate] = useState(new Date(new Date().toDateString()));
  const [toDate, setToDate] = useState(null);
  const [statData, setStatData] = useState(null);
  const [displayedRobots, setDisplayedRobots] = useState(new Map());
  const [robotSummaryData, setRobotSummaryData] = useState({});
  const [initialized, setInitialized] = useState(false);

  const setDateRange = useCallback(
    (newFromDate, newToDate) => {
      setFromDate(newFromDate);
      setToDate(newToDate);

      getReportByDate(fleetId, newFromDate, newToDate)
        .then(function (data) {
          setStatData(data);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    [fleetId]
  );

  useEffect(() => {
    if (!fleetData) {
      return;
    }
    fleetData.forEach((fleet) => {
      if (fleet.id === fleetId) {
        setSelectedFleet(fleet);
      }
    });
    if (!initialized) {
      setDateRange(fromDate, toDate);
      setInitialized(true);
    }
  }, [fleetData, fleetId, fromDate, initialized, setDateRange, toDate]);

  return (
    <React.Fragment>
      <Box display={"flex"} sx={{ flexDirection: "column" }}>
        <Header
          fleetId={fleetId}
          selectedFleet={selectedFleet}
          fromDate={fromDate}
          toDate={toDate}
          setDateRange={setDateRange}
        ></Header>
        <FleetSummary
          fromDate={fromDate}
          toDate={toDate}
          data={statData}
        ></FleetSummary>
        <RobotSummary
          data={statData}
          displayedRobots={displayedRobots}
          setDisplayedRobots={setDisplayedRobots}
          robotSummaryData={robotSummaryData}
          setRobotSummaryData={setRobotSummaryData}
        ></RobotSummary>
        {toDate === null ? (
          <SoloDayGraphList
            data={statData}
            displayedRobots={displayedRobots}
            robotSummaryData={robotSummaryData}
          ></SoloDayGraphList>
        ) : (
          <MultiDayGraphList
            data={statData}
            displayedRobots={displayedRobots}
            fromDate={fromDate}
            toDate={toDate}
          ></MultiDayGraphList>
        )}
      </Box>
    </React.Fragment>
  );
}

export default ReportPage;
